import * as React from 'react';
import createCtx, { InnerContext } from '@narvar/nth-hook-context';
import {
  RequestDeliveryInstructionsAddressVerificationFields,
  LocationDetail,
} from '../../server/api/schema';

export enum UI_STATE {
  HIDDEN,
  INITIAL,
  VERIFY_ADDRESS,
  SELECT_LOCATION,
  CONFIRM_LOCATION,
  SUCCESS,
  POST_SUCCESS,
}

interface RedirectToHoldContext {
  uiState: UI_STATE;
  uniqueIdentifier?: string;
  address?: RequestDeliveryInstructionsAddressVerificationFields;
  selectedLocation?: LocationDetail;
  eligibilityWarning?: string | null;
}

export const DEFAULT_REDIRECT_TO_HOLD_CONTEXT: RedirectToHoldContext = {
  uiState: UI_STATE.HIDDEN,
  eligibilityWarning: null,
};

const [RedirectToHoldContext, RedirectToHoldProvider] = createCtx(
  DEFAULT_REDIRECT_TO_HOLD_CONTEXT,
);

export { RedirectToHoldProvider };

export const useRedirectToHoldContext =
  (): InnerContext<RedirectToHoldContext> =>
    React.useContext(RedirectToHoldContext);
